// extracted by mini-css-extract-plugin
export default {"logo-container":"LogoContainer_logo-container__tqERa","logo-image":"LogoContainer_logo-image__u31tZ","logo-tagline":"LogoContainer_logo-tagline__VaFlj"};